/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Subtext_Url_WrongInputs */



/**
* | output |
* | --- |
* | "The URL looks wrong, or the page was removed." |
*
* @param {Error_Notfound_Subtext_Url_WrongInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_subtext_url_wrong = /** @type {((inputs?: Error_Notfound_Subtext_Url_WrongInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Subtext_Url_WrongInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die URL sieht falsch aus, oder die Seite wurde entfernt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'URL semble incorrecte, ou la page a été supprimée.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("网址看起来有误，或者页面已被移除。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("網址看起來不對，或這個頁面已被移除。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("URL이 잘못되었거나 페이지가 삭제되었습니다.")
	return /** @type {LocalizedString} */ ("The URL looks wrong, or the page was removed.")
});